import { useEffect, useMemo, useState } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { useGetPlanYearsQuery } from '../queries';

interface Params {
  organizationId?: string;
  isDisabled?: boolean;
}
const usePlanYearActions = ({ organizationId, isDisabled }: Params) => {
  const { isLoading, options, isError, refetch } = useGetPlanYearsQuery({
    disabled: isDisabled,
    organizationId,
  });

  const [currentYear, setCurrentYear] = useState<OptionKey | null>(options?.[0]?.key || null);
  useEffect(() => {
    if (!currentYear && options?.length) {
      setCurrentYear(options[0].key);
    }
  }, [currentYear, options]);
  const currentPlanYearTitle = useMemo(
    () => options?.find((item) => item.key === currentYear)?.value,
    [currentYear, options]
  );

  return {
    options,
    isError,
    isLoading,
    currentYear,
    setCurrentYear,
    currentPlanYearTitle,
    refetch,
  };
};

export default usePlanYearActions;
